import { Box } from '@mui/material';
import React from 'react';

const SmallNotes = (props) => {
    const { notes } = props;

    return (
        <Box>
            {
                notes && notes.length > 0 ? (
                    <div className="flex flex-col gap-2">
                        {notes.map((note, index) => (
                            <p className='text-xx-small'><span className='error-500'>*</span>{note}</p>
                        ))}
                    </div>
                ) : (
                    null
                )
            }
        </Box>
        
    );

}
    
;

export default SmallNotes;